<script>
import Multiselect from "vue-multiselect";
import {cloneDeep} from 'lodash'
export default {
    name: "KpiTag",
    components: {
        Multiselect,
    },
    data(){
        return{
            tags: [],
            selection: [],
            submitted: false,
            tagSelection: [],
        }
    },
    async created(){
        try {
            const {data} = await this.$store.dispatch('indicatoritemtag/GetAllItemTag')
            this.selection = data;
        }catch(err){
            this.showToast('Something went wrong', 'error')
        }
    },
    methods: {
        dropData(){
            this.$emit('drop-data', this.tags)
            this.$bvModal.hide('kpi-tag-modal')
        },
        resetTags(tags){
            this.tags = [];
            let resetTag = cloneDeep(this.selection);
            tags.forEach(tag => {
                let index = resetTag.findIndex(item => item.id == tag.id)
                if(index > -1){
                    resetTag.splice(index, 1)
                }
            })
            this.tagSelection = resetTag;
        }
    }
}
</script>
<template>
  <div>
    <b-modal
        id="kpi-tag-modal"
        title="Selection of KPI Tags"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <div>
            <multiselect
                v-model="tags"
                :options="tagSelection"
                label="name"
                track-by="id"
                value="id"
                :allow-empty="true"
                :close-on-select="false"
                :clear-on-select="true"
                :preserve-search="true"
                :multiple="true"
                :hide-selected="true"
            />
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary" v-if="tags.length > 0" @click="dropData">
                Add This Tags
            </button>
            <button
                type="button"
                class="btn btn-link"
                @click="$bvModal.hide('kpi-tag-modal')"
            >
                Close
            </button>
        </div>
    </b-modal>
  </div>
</template>